import { useCallback, useId, useMemo, useRef, useState } from "react";
import type { editor } from "monaco-editor";
import { useEditorView } from "./react.tsx";
import type { EditorWidgetCallbacks } from "./widget-service.ts";
export interface CodeEditorProps {
  readonly currentFile: string | undefined;
  readonly viewStates?: Map<string, editor.ICodeEditorViewState | null>;
  readonly viewStateScope?: object;
  readonly onChange: (filename: string, contents: string) => void;
  readonly onMount?: ((editor: editor.IStandaloneCodeEditor) => void) | undefined;
  readonly onUnmount?: ((editor: editor.IStandaloneCodeEditor) => void) | undefined;
}
export function CodeEditor({ currentFile, viewStates, viewStateScope, onChange, onMount, onUnmount }: CodeEditorProps) {
  const [container, setContainer] = useState<HTMLDivElement | null>(null), local = useRef(new Map<string, editor.ICodeEditorViewState | null>());
  const latest = useMemo<{ current: EditorWidgetCallbacks }>(() => ({ current: { viewStates: viewStates ?? local.current, onChange, onMount, onUnmount } }), [viewStateScope]);
  latest.current = { viewStates: viewStates ?? local.current, onChange, onMount, onUnmount };
  const callbacks = useCallback(() => latest.current, [latest]), identity = useId();
  const failure = useEditorView(container, identity, currentFile, callbacks);
  return <div className="relative min-h-[380px] w-full flex-1"><div ref={setContainer} className="absolute inset-0" />{failure ? <div role="alert" className="absolute inset-x-3 top-3 z-10 rounded border border-status-error bg-kumo-base p-3 text-xs text-status-error">{failure}</div> : null}</div>;
}
